import { put, call, take, fork } from 'redux-saga/effects'
import generalSaga from '../general'
import { USER_PASSWORD_SET } from '../../reducers/user-password/type'
import { userPasswordSetService } from '../../api/user-password'
import { userPasswordSetSuccess } from '../../reducers/user-password/action'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* userPasswordSetFlow(payload) {
  try {
    const { entity, callback } = payload
    const response = yield call(userPasswordSetService, entity)

    yield put(userPasswordSetSuccess(response))
    yield put(operationSuccess())
    //window.location.href = '/set-password-success'
    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* userPasswordSetWatcher() {
  while (true) {
    const action = yield take(USER_PASSWORD_SET)
    const { payload } = action

    yield fork(generalSaga, userPasswordSetFlow, payload)
  }
}
